import { render, staticRenderFns } from "./BaseFormItem.vue?vue&type=template&id=eb2b5464&scoped=true&"
import script from "./BaseFormItem.vue?vue&type=script&lang=js&"
export * from "./BaseFormItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormItem.vue?vue&type=style&index=0&id=eb2b5464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2b5464",
  null
  
)

export default component.exports